import { useControls, button } from "leva";
import useFlowStore from "../components/store/flowStore";

export default function FlowDebugger() {
  const {
    flowSteps,
    setStep,
    nextStepDebug,
    switchCurrentCamera,
    playCamera,
    playCurrentAudio,
    previousStep,
    resetFlow,
    finishAudio, // <-- Ajoute ici
  } = useFlowStore();

  // ⛔️ Ne rien rendre ni appeler useControls en production
  if (!import.meta.env.DEV) return null;

  const stepOptions = flowSteps.reduce((acc, step) => {
    acc[`${step.id} - ${step.label}`] = step.id;
    return acc;
  }, {});

  useControls("Timeline", {
    "⏩ Next Step": button(() => nextStepDebug()),
    "▶️ Play Audio": button(() => playCurrentAudio()),
    "🎥 Play Camera": button(() => playCamera()),
    "🎥 Switch Camera": button(() => switchCurrentCamera()),
    "⏪ Previous Step": button(() => previousStep()),
    "🔄 Reset Flow": button(() => resetFlow()),
    "⏹ Terminer l'audio": button(() => finishAudio()), // <-- Ajoute ce bouton
    "📍 Aller à la step": {
      options: stepOptions,
      onChange: (val) => {
        console.log("🔧 [FlowDebugger] setStep:", val);
        setStep(val);
      },
    },
  });

  return null;
}
